import React from 'react';
import EventDateViewer from './EventDateViewer';
import EventWinnerViewButton from './EventWinnerViewButton';
import EventMediaViewer from './EventMediaViewer';

const OldEventListItem = (props) => {
  const { postInfo } = props;
  return (
    <li>
      <figure className="thumb-notice">
        <EventMediaViewer postInfo={postInfo} type="oldList" />
        <figcaption className="info-area">
          <p className="title">{postInfo.title}</p>
          <div className="info-body">
            <EventDateViewer postInfo={postInfo} />
          </div>
          <div className="info-foot">
            <EventWinnerViewButton {...props} />
          </div>
        </figcaption>
      </figure>
    </li>
  );
};

export default OldEventListItem;
